module.exports = __webpack_public_path__ + "static/img/60_tummy.f17e462d.jpg";